// extracted by mini-css-extract-plugin
export default {"ModalPadding":"0.5rem","modalBody":"Gb5ed1e"};